import styled from "styled-components";

import { OpacityAnimation } from "../../../utils/KeyFrames";

export const AnimatedWrap = styled.div`
  animation: ${OpacityAnimation} 0.5s ease-out 0s forwards;
`;
